module.exports = __webpack_public_path__ + "static/media/SelectedBulbGrey.1239030f.svg";